import { call, all, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { apiPatch, buildApiURL } from '@src/services/api';
import { handleSagaFailure } from '@src/utils/sagaHelpers';

import { actions, types as impactingPolicyTypes } from '../ducks/impactingPolicy';

export function * watchImpactingPolicy() {
    yield takeLatest(impactingPolicyTypes.IMPACTING_POLICY_GET, onImpactingPolicyGet);
    yield takeLatest(impactingPolicyTypes.IMPACTING_POLICY_SUCCESS, onImpactingPolicyGetResponse);
    yield takeEvery(impactingPolicyTypes.IMPACTING_POLICY_MARK_AS_READ, onMarkAsRead);
}

function * onImpactingPolicyGet({ payload }) {
    payload.method = 'get';
    return yield payload;
}

function * onImpactingPolicyGetResponse({ response, payload }) {
    if (payload.action === 'get' && response && payload.dataset === 'impacting_policy') {
        return yield all([
            put({
                type: impactingPolicyTypes.IMPACTING_POLICY_SET,
                payload: response,
            }),
        ]);
    }
}

function * onMarkAsRead({ payload }) {
    try {
        const response = yield call(
            apiPatch,
            buildApiURL(`/api/v1/impacting_policies/${payload.id}/mark_as_read`),
            {},
        );

        yield put(actions.updateMarkAsReadSuccess(response));
    } catch (error) {
        yield call(handleSagaFailure, error);
        yield put(actions.updateMarkAsReadFailure(error));
    }
}
